import { GetLeadEventsFilter } from './get-lead-events.filter';

export class GetLeadEventsInput {
    leadId: string;
    filter: GetLeadEventsFilter;
}
